import { Button } from '@zyxantech/tux'
import { Compass } from 'lucide-react'
import { useNavigate } from 'react-router-dom'
import { EmptyState } from '@/components/shared/EmptyState'
import { ROUTES } from '@/constants/routes'

/** 404 — route not found or a module not active in this deployment. */
export function NotFoundPage() {
  const navigate = useNavigate()
  return (
    <EmptyState
      icon={<Compass size={32} />}
      title="Page not found"
      message="This page doesn't exist, or the module isn't enabled for your deployment."
      action={<Button onClick={() => navigate(ROUTES.OVERVIEW)}>Back to overview</Button>}
    />
  )
}
